import { useState, useRef } from 'react';
var ACCEPTED_TYPES = 'application/pdf,image/jpeg,image/jpg,image/png';
var isValidFile = function (file, accept) {
    var fileType = file.type;
    var fileName = file.name.toLowerCase();
    if (!fileType && !fileName)
        return false;
    return accept.split(',').some(function (type) {
        var trimmedType = type.trim().toLowerCase();
        if (fileType && (fileType === trimmedType || fileType.startsWith(trimmedType.split('/')[0] + '/'))) {
            return true;
        }
        if (trimmedType === 'application/pdf')
            return fileName.endsWith('.pdf');
        if (trimmedType.includes('image'))
            return /\.(png|jpe?g)$/i.test(fileName);
        var parts = trimmedType.split('/');
        if (parts.length === 2)
            return fileName.endsWith("." + parts[1]);
        return false;
    });
};
export var useCardDragDrop = function (onFilesDropped, disabled, accept) {
    if (disabled === void 0) { disabled = false; }
    if (accept === void 0) { accept = ACCEPTED_TYPES; }
    var _a = useState(false), isDragging = _a[0], setIsDragging = _a[1];
    var dragCounter = useRef(0);
    var handleDragEnter = function (e) {
        e.preventDefault();
        if (disabled)
            return;
        dragCounter.current++;
        if (e.dataTransfer.types.includes('Files'))
            setIsDragging(true);
    };
    var handleDragLeave = function (e) {
        e.preventDefault();
        if (disabled)
            return;
        dragCounter.current--;
        if (dragCounter.current === 0)
            setIsDragging(false);
    };
    var handleDragOver = function (e) {
        e.preventDefault();
    };
    var handleDrop = function (e) {
        e.preventDefault();
        dragCounter.current = 0;
        setIsDragging(false);
        if (disabled)
            return;
        var validFiles = Array.from(e.dataTransfer.files).filter(function (file) {
            return isValidFile(file, accept);
        });
        if (validFiles.length > 0)
            onFilesDropped(validFiles);
    };
    return { isDragging: isDragging, handleDragEnter: handleDragEnter, handleDragLeave: handleDragLeave, handleDragOver: handleDragOver, handleDrop: handleDrop };
};
